import type { UXCamConfiguration } from "cordova-uxcam";
import { routes } from "../route/constants";

// cordova-uxcam UXCamOcclusionType.OccludeAllTextFields — occlude every text
// field on the listed screens. Hardcoded (rather than imported from
// `cordova-uxcam`) so pulling in the config on web/Cypress doesn't trigger the
// package's `window.UXCam = ...` backward-compat side effect. UXCam.test.ts
// asserts this value against the real enum so a renumber fails CI.
const OCCLUDE_ALL_TEXT_FIELDS = 3;

export const UXCamConfig: UXCamConfiguration = {
    userAppKey: process.env.REACT_APP_UX_CAM_KEY ?? "",
    enableAutomaticScreenNameTagging: false,
    enableImprovedScreenCapture: true,
    // REFSIX-776: recording now starts before registration, so the register and
    // login screens (the only ones where a password is entered) must have their
    // inputs obfuscated in replays. Scope the occlusion to just those screens —
    // the rest of the pre-registration journey is still captured. Screen names
    // are the router pathnames tagged by PageViewAnalytics, so reuse the shared
    // routes constants to keep them from drifting.
    occlusions: [
        {
            type: OCCLUDE_ALL_TEXT_FIELDS,
            screens: [routes.register, routes.login],
        },
    ],
};
